/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Help = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z"
                        fill={color}
                    />
                    <path
                        d="M14.2507 6.88759C13.2675 5.90439 11.7413 5.71651 10.549 6.43189L10.3793 6.53371C9.70719 6.93699 9.20149 7.56741 8.95361 8.31104L8.75 8.92187L10.173 9.39621L10.3766 8.78538C10.5113 8.38145 10.786 8.03901 11.1511 7.81995L11.3208 7.71813C11.9229 7.35687 12.6936 7.45175 13.1901 7.94825C13.8203 8.57853 13.7806 9.61198 13.1039 10.1921L12.2327 10.9388C11.5845 11.4944 11.2115 12.3054 11.2115 13.159V14.5H12.7115V13.159C12.7115 12.7433 12.8932 12.3483 13.2089 12.0777L14.0801 11.3309C15.4202 10.1822 15.4988 8.13571 14.2507 6.88759Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
